module.exports = __webpack_public_path__ + "static/media/squared.b2c19076.jpg";